<template>
  <ControlCommonLayout header="controlHeader" footer="controlFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container">
        <div class="main-color text-light row mt-3">
          <div v-if="mode === 'regist'" class="col p-2">
            スペック案件(新規)
          </div>
          <div v-if="mode === 'edit'" class="col p-2">
            スペック案件(編集)
          </div>
          <div v-if="mode !== 'regist' && mode !== 'edit'" class="col p-2">
            スペック案件(参照)
          </div>
        </div>

        <!-- 案件情報部分 -->
        <div id="search-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist">
            <b-card no-body>
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-1 id='search-bar' class="light-blue text-left text-black" @click="changeIcon()"><b-icon id="icon-up" icon="chevron-up"></b-icon><b-icon id="icon-down" class="hide" icon="chevron-down"></b-icon>&nbsp;案件情報</b-button>
              </b-card-header>
              <!-- 制作案件一覧検索BOX -->
              <b-collapse visible id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal" onsubmit="return false;">
                    <div v-if="mode === 'regist'" class="text-left mb-3" >
                      <b-button variant="secondary" type="button" class="w-5 white-btn" @click="clickBack()">戻る</b-button>
                    </div>
                    <div v-if="mode === 'edit'" class="text-left mb-3" >
                      <b-button variant="secondary" type="button" class="w-5 white-btn" @click="goConfirmation()">キャンセル</b-button>
                      <b-button variant="primary" type="button" class="w-5 white-btn" @click="specUpdate()">保存</b-button>
                    </div>
                    <div v-if="mode !== 'regist' && mode !== 'edit'" class="text-left mb-3" >
                      <b-button variant="secondary" type="button" class="w-5 white-btn" @click="goBack()">戻る</b-button>
                      <b-button variant="primary" type="button" class="w-5 white-btn" @click="goEdit()" :disabled="(userRoleMode == 0 || (userRoleMode == 1 && (!userEditAuthority || setStatus == '売上日報完了')))">編集</b-button>
                      <b-button variant="primary" type="button" class="w-5 white-btn" @click="goSpecInfo(false)">案件情報</b-button>
                    </div>
                    <div class="form-group row">
                      <div v-if="mode === 'regist'" class="col-sm-4">
                        <td class="p-1 light-blue label-condition">案件フラグ</td>
                        <td class="p-1">
                          <select id="ankenFlg" class="form-control input-sm set-condition" name="ankenFlg" v-model="setAnkenFlg">
                            <option value="1">1</option>
                            <option value="1.5">1.5</option>
                            <option value="3">3</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                          </select>
                        </td>
                      </div>
                      <div v-if="mode !== 'regist'" class="col-sm-4">
                        <td class="p-1 light-blue label-condition">ID</td>
                        <td class="p-1">{{projectNumber}}</td>
                      </div>
                      <div v-if="mode === 'regist'" class="col-sm-4">
                        <td class="p-1 light-blue label-condition">メインテーブル<br>合計金額</td>
                        <td class="p-1">{{toCommaSeparated(setMainPrice)}}</td>
                      </div>
                      <div v-if="mode === 'regist'" class="col-sm-4">
                        <td class="p-1 light-blue label-condition">ゲストテーブル<br>合計金額</td>
                        <td class="p-1">{{toCommaSeparated(setGuestPrice)}}</td>
                      </div>
                      <div class="col-sm-4" v-if="mode !== 'regist'">
                        <td class="p-1 light-blue label-condition">スタイル</td>
                        <td class="p-1">{{changeArrayFormat(setStyle)}}</td>
                      </div>
                      <div v-if="mode !== 'regist'" class="col-sm-4">
                        <td class="p-1 light-blue label-condition">季節</td>
                        <td v-if="mode === 'regist' || mode === 'edit'" class="p-1">
                          <select id="season" class="form-control input-sm set-condition" style="width: auto;" v-model="setSeason">
                            <option value="">選択してください</option>
                            <option v-for="(season, index) in getSeasons()" :key="index + 'season'" :value="season['名称']['value']">{{season['名称']['value']}}</option>
                          </select>
                        </td>
                        <td v-else class="p-1">{{setSeason}}</td>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4" v-if="mode !== 'regist'">
                        <td class="p-1 light-blue label-condition">作成日</td>
                        <td class="p-1">{{changeDateFormat(setMakeDate)}}</td>
                      </div>
                      <div v-if="mode === 'regist'" class="col-sm-4">
                        <td class="p-1 light-blue label-condition">季節</td>
                        <td v-if="mode === 'regist' || mode === 'edit'" class="p-1">
                          <select id="season" class="form-control input-sm set-condition" style="width: auto;" v-model="setSeason">
                            <option value="">選択してください</option>
                            <option v-for="(season, index) in getSeasons()" :key="index + 'season'" :value="season['名称']['value']">{{season['名称']['value']}}</option>
                          </select>
                        </td>
                        <td v-else class="p-1">{{setSeason}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">施行日</td>
                        <td v-if="mode === 'regist' || mode === 'edit'" class="p-1">
                          <input type="date" id="specDate" class="form-control input-sm set-condition" v-model="setSpecDate" @blur="autoChangeSeason"/>
                        </td>
                        <td v-else class="p-1">{{changeDateFormat(setSpecDate, 'constructionDate')}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">施設コード</td>
                        <td v-if="mode === 'regist' || mode === 'edit'" class="p-1">
                          <input type="text" id="facilityCode" class="form-control input-sm set-condition" v-model="setFacilityCode" @blur="autoChangeFacility"/>
                        </td>
                        <td v-else class="p-1">{{setFacilityCode}}</td>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">エリア</td>
                        <td class="p-1">{{setArea}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">ユニット</td>
                        <td class="p-1">{{setUnit}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">施設名</td>
                        <td class="p-1">{{setFacilityName}}</td>
                      </div>
                    </div>
                    <div v-if="mode !== 'regist'" class="form-group row">
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">メイン形状</td>
                        <td class="p-1" style="white-space: pre-wrap;">{{setMainShape}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">ゲスト形状</td>
                        <td class="p-1" style="white-space: pre-wrap;">{{setGuestShape}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">色</td>
                        <td class="p-1">{{changeArrayFormat(setColor)}}</td>
                      </div>
                    </div>
                    <div v-if="mode !== 'regist'" class="form-group row">
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">案件フラグ
                          <div v-if="mode === 'edit'">
                            <br>&emsp;
                          </div>
                        </td>
                        <td v-if="mode === 'edit'" class="p-1">
                          <select id="ankenFlg" class="form-control input-sm set-condition" name="ankenFlg" v-model="setAnkenFlg">
                            <option value="1">1</option>
                            <option value="1.5">1.5</option>
                            <option value="3">3</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                          </select>
                        </td>
                        <td v-else class="p-1">{{setAnkenFlg}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">企画担当者コード</td>
                        <td v-if="mode === 'edit'" class="p-1">
                          <input type="text" id="tantoshaCode" class="form-control input-sm set-condition" v-model="setTantoshaCode" @blur="autoChangeTantosha"/>
                          <select id="tantosha" class="form-control input-sm set-condition" v-model="setTantosha" @change="autoChangeTantoshaCode">
                            <option value="">選択してください</option>
                            <option v-for="(tantosha, index) in getTantoshaData()" :key="index + 'tantosha'" :value="tantosha['担当者']['value'][0]['name']">{{tantosha['担当者']['value'][0]['name']}}</option>
                          </select>
                        </td>
                        <td v-else class="p-1">{{setTantosha}}</td>
                      </div>
                      <div class="col-sm-4">
                        <td class="p-1 light-blue label-condition">企画シート
                          <div v-if="mode === 'edit'">
                            <br>&emsp;
                          </div>
                        </td>
                        <td v-if="mode === 'edit'" class="p-1">
                          <a class="text-blue" @click="clickUploadPdf()" accept=".pdf" v-if="!setPlanningSheet">アップロード</a>
                          <a :href="setPlanningSheet" v-if="setPlanningSheet" target="_blank" rel="noopener noreferrer">{{setPlanningSheetName}}</a>
                          <div style="text-align: right;bottom: 0;right: 15px;position: absolute;">
                            <a class="text-blue" @click="clickClearPdf()" v-if="setPlanningSheet">クリア</a>
                          </div>
                          <input id="pdf-file-input-pdf" class="d-none" type="file" @change="uploadPdf($event)">
                        </td>
                        <td v-else class="p-1">
                          <a :href="setPlanningSheet" target="_blank" rel="noopener noreferrer">
                            {{setPlanningSheetName}}
                          </a>
                        </td>
                      </div>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- 画像リスト -->
        <div class="row mt-3 base-color">
          <div v-if="mode !== 'regist'" class="col-sm-12 row pt-3 pr-0">
            <div class="card-deck p-3 w-100" v-for="(image_info, index) in deliveryImageData()" :key="index">
              <div class="card mr-1 ml-1" v-for="(image, i) in image_info" :key="i">
                <div class="card-header text-center p-0 card-sqr-gray tile-image-dev" v-if="image.filePath !== null">
                  <img :src="image.filePath" class="mw-100 tile-image-height" @click="clickImage(i + (index  * imageRowMaxNum))" >
                </div>
                <div class="card-header p-0" v-else>
                  <div class="tile-image-dev text-center pt-4" v-if="image.type !== '06'">
                    <p class="mb-1">{{image.typeName}}</p>
                    <b-icon icon="image" font-scale="2"></b-icon>
                    <p>no Image</p>
                  </div>
                  <div class="tile-image-dev text-center pt-5" v-else>
                    <b-icon icon="image" font-scale="2"></b-icon>
                    <p>no Image</p>
                  </div>
                </div>
                <div class="card-body">
                  <p class="card-title" v-if="image.type !== '06'">{{(i + 1) + (index * imageRowMaxNum)}}.{{image.typeName}}</p>
                  <p class="card-title" v-else>{{image.typeName}}{{(i + 1) + (index  * imageRowMaxNum)}}</p>
                  <p class="mb-1">任意</p>
                  <div v-if="mode === 'regist' || mode === 'edit'" class="row">
                    <div class="col">
                      <button v-if="image.filePath !== null" type="button" class="btn pl-0 text-blue" @click="clickRotate(i + (index  * imageRowMaxNum))">
                        <b-icon icon="arrow-clockwise"></b-icon>
                      </button>
                      <button v-if="image.filePath === null" type="button" class="btn pl-0" @click="clickRotate(i + (index  * imageRowMaxNum))" disabled>
                        <b-icon icon="arrow-clockwise"></b-icon>
                      </button>
                    </div>
                    <div class="text-right col text-nowrap pt-2">
                      <a class="text-blue" @click="clickUploadImage(i + (index * imageRowMaxNum))" v-if="image.filePath === null">画像を登録</a>
                      <a class="text-blue" @click="clickClear(i + (index * imageRowMaxNum))" v-else>画像クリア</a>
                      <input :id="'image-file-input-' + (i + (index  * imageRowMaxNum))" class="d-none" type="file" @change="uploadImage(i + (index  * imageRowMaxNum), $event)">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 商品リスト -->
          <div class="col-sm-12 row pt-3 pr-0 ml-1">
            商品
          </div>
          <div v-if="mode === 'regist' || mode === 'edit'" class="col-sm-12 mt-3" style="justify-content: space-between; display: flex;">
            <b-button variant="primary" @click="itemAdd()">商品追加</b-button>
            <b-button v-if="mode === 'edit'" variant="primary" type="button" class="w-5 white-btn" style="width: auto" @click="specUpdate()">保存</b-button>
          </div>
          <b-overlay :show="overlayItemListShow" rounded="sm" class="col-sm-12">
            <div class="col-sm-12 mt-3">
              <b-table-simple bordered class="small">
                <thead role="rowgroup" class="table-bordered">
                  <tr role="row" class="align-middle">
                    <th rowspan="1" class="align-middle text-center" style="width: 9%;">商品コード</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 11%;">大区分</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 11%;">中区分</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 13%;">小区分</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 13%;">商品名</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 8%;">商品単価</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 6%;">数量</th>
                    <th rowspan="1" class="align-middle text-center" style="width: 9%;">商品金額計</th>
                    <th rowspan="1" class="align-middle text-center" style="width: auto;">備考</th>
                    <th v-if="mode === 'regist' || mode === 'edit'" rowspan="1" class="align-middle text-center" style="width: 8%;"></th>
                  </tr>
                </thead>
                <template v-for="(item, index) in itemList">
                  <b-tbody :key="index + 'tbody'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'" draggable @dragstart="dragStartList($event, index)" @dragend="dragEndList($event)" @drop="dropList($event, index)" @dragover.prevent @dragenter.prevent>
                    <b-tr :key="index + 'item'">
                      <b-td class="align-middle">{{item['value']['メインゲスト商品コード'] ? item['value']['メインゲスト商品コード']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['value']['メイン_ゲスト商品_大区分'] ? item['value']['メイン_ゲスト商品_大区分']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['value']['メインゲスト中区分'] ? item['value']['メインゲスト中区分']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['value']['メイン_ゲスト商品_小区分'] ? item['value']['メイン_ゲスト商品_小区分']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['value']['メインゲスト商品名'] ? item['value']['メインゲスト商品名']['value'] : ''}}</b-td>
                      <b-td v-if="mode === 'regist' || mode === 'edit'" class="align-middle">
                        <input type="text" class="form-control input-sm" style="padding:0.2rem;" v-model="item['value']['メインゲスト商品単価']['value']" @change="changeKingaku(index)"/>
                      </b-td>
                      <b-td v-else class="align-middle">{{item['value']['メインゲスト商品単価'] ? toCommaSeparated(item['value']['メインゲスト商品単価']['value']) : ''}}</b-td>
                      <b-td v-if="mode === 'regist' || mode === 'edit'" class="align-middle">
                        <input type="text" class="form-control input-sm" style="padding:0.2rem;" v-model="item['value']['メインゲスト数量']['value']" @change="changeKingaku(index)"/>
                      </b-td>
                      <b-td v-else class="align-middle">{{item['value']['メインゲスト数量'] ? item['value']['メインゲスト数量']['value'] : ''}}</b-td>
                      <b-td class="align-middle">{{item['value']['メインゲスト商品金額計'] ? toCommaSeparated(item['value']['メインゲスト商品金額計']['value']) : ''}}</b-td>
                      <b-td v-if="mode === 'regist' || mode === 'edit'" class="align-middle">
                        <b-form-textarea class="w-100 item-note" name="note" rows="2" max-rows="50" maxlength="50" style="padding:0.2rem;" v-model="item['value']['メインゲスト備考']['value']"></b-form-textarea>
                      </b-td>
                      <b-td v-else class="align-middle">{{item['value']['メインゲスト備考'] ? item['value']['メインゲスト備考']['value'] : ''}}</b-td>
                      <b-td v-if="mode === 'regist' || mode === 'edit'" class="align-middle" style="text-align: center;">
                        <b-button variant="danger" @click="itemDel(index)">削除</b-button>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
          </b-overlay>
          <div v-if="mode === 'regist'" class="col-sm-12 mt-3 text-right">
            <b-button variant="primary" @click="specRegist()">新規登録</b-button>
          </div>
        </div>
      </div>
    </b-overlay>
    <CommonModal ref="commonModal" />
    <CommonModal ref="commonModalRotate" @confirmOk="clickRotateImage" />
    <CommonModal ref="commonModalClear" @confirmOk="clickDeleteImage" />
    <CommonModal ref="commonModalClearPdf" @confirmOk="clickDeletePdf" />
    <CommonModal ref="commonModalBack" @confirmOk="goBack()" />
  </ControlCommonLayout>
</template>
<script>
import ControlCommonLayout from '@/layout/ControlCommonLayout'
import CommonModal from '@/components/CommonModal'
import SpecListModel from '@/models/SpecListModel'
import SpecImageModel from '@/models/SpecImageModel'
import SpecPdfModel from '@/models/SpecPdfModel'
import SearchFacilityModel from '@/models/SearchFacilityModel'

export default {
  name: 'ControlSpecRegistration',
  components: { ControlCommonLayout, CommonModal, SpecImageModel, SpecPdfModel, SearchFacilityModel },
  data () {
    return {
      mode: '',
      overlayShow: false,
      overlayItemListShow: false,
      setAnkenFlg: '1',
      setMainPrice: '',
      setGuestPrice: '',
      setSeason: '',
      setSpecDate: '',
      setFacilityCode: '',
      setArea: '',
      setUnit: '',
      setFacilityName: '',
      setStyle: [],
      setColor: [],
      setMakeDate: '',
      setTantosha: '',
      setTantoshaCode: '',
      setPlanningSheet: '',
      setPlanningSheetName: '',
      setPlanningSheetData: '',
      setStatus: '',
      seasonData: [],
      setMainShape: '',
      setGuestShape: '',
      tantoshaData: [],
      imageRowMaxNum: 5,
      imageInfos: [],
      resizeImages: [],
      itemList: [],
      userId: '',
      userRole: '',
      userRoleMode: '',
      userEditAuthority: false,
      toroku: false,
      projectNumber: '',
      projectNumberUrl: '',
      AnkenNumber: '',
      NowDragIndex: -1
    }
  },
  methods: {
    setApiData: async function (isReload = false) {
      console.log(this.$route.meta)
      console.log(this.$route.query)
      if (this.$route.meta.userId) {
        this.userId = this.$route.meta.userId
        localStorage.setItem('controlUserId', this.userId)
      } else {
        this.userId = localStorage.getItem('controlUserId')
      }
      if (this.$route.meta.userId) {
        this.toroku = (this.$route.meta.toroku === 'true')
        localStorage.setItem('controlToroku', JSON.stringify(this.toroku))
      } else {
        this.toroku = (localStorage.getItem('controlToroku') === 'true')
      }
      console.log(this.userId)
      console.log(this.toroku)

      if (this.$route.query.mode) {
        this.mode = this.$route.query.mode
      }
      if (this.$route.query.projectNumber) {
        this.projectNumber = this.$route.query.projectNumber
      }

      this.userRole = localStorage.getItem('controlUserRole')
      this.userEditAuthority = (localStorage.getItem('controlUserEditAuthority') !== 'false')
      console.log(this.userRole)
      console.log(this.userEditAuthority)

      // ユーザーの役割に応じたモード変更
      this.setUserRoleMode()
      console.log(this.userRoleMode)

      this.setIni()
    },
    setIni: async function () {
      this.overlayShow = true

      if (JSON.parse(localStorage.getItem('isPageBack'))) {
        console.log('pageback処理')
        await this.pageBackDataSetUp()
        this.mathMainGuestPrice()
        localStorage.removeItem('isPageBack')
      } else {
        scrollTo(0, 0)

        const param = {
          'mode': this.mode,
          'projectNumber': this.projectNumber
        }
        const result = await SpecImageModel.getApi(this.$bvModal, param, (result) => {})
        console.log(result)
        if ('items' in result) {
          this.imageInfos = result['items'].map(elm => {
            elm['isAddFile'] = false
            return elm
          })
        }
        console.log(this.imageInfos)

        // 登録モード以外だと、取得した情報を画面に反映させる。
        if (this.mode !== 'regist') {
          if ('projectInfo' in result && result['projectInfo']) {
            this.setAnkenFlg = result['projectInfo']['案件フラグ']['value']
            this.setSeason = result['projectInfo']['季節']['value']
            this.setSpecDate = result['projectInfo']['施工日']['value']
            this.setFacilityCode = result['projectInfo']['施設コード']['value']
            this.setArea = result['projectInfo']['エリア']['value']
            this.setUnit = result['projectInfo']['ユニット']['value']
            this.setFacilityName = result['projectInfo']['施設名']['value']
            this.setStyle = result['projectInfo']['スタイル']['value']
            this.setColor = result['projectInfo']['色']['value']
            this.setMakeDate = result['projectInfo']['作成日時']['value']
            this.setTantosha = (result['projectInfo']['担当者']['value'].length > 0) ? result['projectInfo']['担当者']['value'][0]['name'] : ''
            this.setTantoshaCode = (result['projectInfo']['担当者']['value'].length > 0) ? result['projectInfo']['担当者']['value'][0]['code'] : ''
            await this.setPlanningSheetUrl(result['planningSheet'])

            this.itemList = result['projectInfo']['メインゲスト商品テーブル']['value']
            this.mathMainGuestPrice()

            this.AnkenNumber = result['projectInfo']['案件番号']['value']
            this.setStatus = result['projectInfo']['案件ステータス']['value']

            if (result['projectInfo']['メイン形状']['value'] && result['mainShape']) {
              this.setMainShape = this.changeToShapeName(result['projectInfo']['メイン形状']['value'], result['mainShape'], 'main')
            }
            if (result['projectInfo']['ゲスト形状']['value'] && result['guestShape']) {
              this.setGuestShape = this.changeToShapeName(result['projectInfo']['ゲスト形状']['value'], result['guestShape'], 'guest')
            }
            console.log(this.setStatus)
            console.log(this.itemList)
          } else {
            this.$refs.commonModal.msgBoxOk('案件情報が取得できませんでした。')
            return false
          }
        }
        this.projectNumberUrl = result['projectNumberUrl']
        console.log(this.projectNumberUrl)
      }

      // 案件情報のアドレス
      const resultIni = await SpecListModel.getApi(this.$bvModal, null, () => {})
      console.log(resultIni)

      if (resultIni['season'] === undefined) {
        console.log('season:undefined')
      } else {
        this.seasonData = resultIni['season']
        this.tantoshaData = resultIni['tantosha']
      }

      this.overlayShow = false
    },
    mathMainGuestPrice () {
      // メインテーブル合計金額、ゲストテーブル合計金額最新化
      this.setMainPrice = 0
      this.setGuestPrice = 0
      for (let i = 0; i < this.itemList.length; i++) {
        let item = this.itemList[i]['value']
        if (this.isNumeric(item['メインゲスト商品金額計']['value'])) {
          if (item['メイン_ゲスト商品_大区分']['value'] === 'メインテーブル') {
            this.setMainPrice += Number(item['メインゲスト商品金額計']['value'])
          } else if (item['メイン_ゲスト商品_大区分']['value'] === 'ゲストテーブル') {
            this.setGuestPrice += Number(item['メインゲスト商品金額計']['value'])
          }
        }
      }
    },
    isNumeric (val) {
      return /^-?\d+$/.test(val)
    },
    isDecimal (val) {
      return new RegExp(/^([1-9]\d*|0)(\.\d{1,2})?$/).test(val)
    },
    toCommaSeparated (str) {
      if (str) {
        try {
          return parseInt(str, 10).toLocaleString()
        } catch (err) {
          return ''
        }
      }
      return str
    },
    changeDateFormat (date, type = '') {
      if (date === null) {
        return null
      }
      if (type === 'constructionDate') {
        date = date.replace('-', '/').replace('-', '/')
      } else {
        date = date.substring(0, date.indexOf('T')).replace('-', '/').replace('-', '/')
      }
      return date
    },
    changeArrayFormat (date) {
      if (date === null) {
        return null
      }

      return date.join('、')
    },
    changeKingaku (index) {
      // 商品単価、商品数量に応じた合計金額の算出
      this.overlayShow = true

      if (this.isDecimal(this.itemList[index]['value']['メインゲスト数量']['value']) &&
        Number(this.itemList[index]['value']['メインゲスト数量']['value']) >= 0 &&
        this.isNumeric(this.itemList[index]['value']['メインゲスト商品単価']['value'])) {
        this.itemList[index]['value']['メインゲスト商品金額計']['value'] = parseInt(Number(this.itemList[index]['value']['メインゲスト商品単価']['value']) * Number(this.itemList[index]['value']['メインゲスト数量']['value']), '10')
      } else {
        this.itemList[index]['value']['メインゲスト商品金額計']['value'] = 'error'
      }
      // 案件情報欄の合計金額を変更
      this.mathMainGuestPrice()

      this.overlayShow = false
    },
    changeAllKingaku () {
      for (let i = 0; i < this.itemList.length; i++) {
        this.changeKingaku(i)
      }
    },
    changeIcon () {
      document.getElementById('icon-up').classList.toggle('hide')
      document.getElementById('icon-down').classList.toggle('hide')
    },
    getSeasons () {
      return this.seasonData
    },
    getTantoshaData () {
      return this.tantoshaData
    },
    deliveryImageData () {
      if (!this.imageInfos) {
        return null
      }
      const length = Math.ceil(this.imageInfos.length / this.imageRowMaxNum)
      const images = new Array(length).fill().map((_, i) =>
        this.imageInfos.slice(i * this.imageRowMaxNum, (i + 1) * this.imageRowMaxNum)
      )
      console.log(images)
      return images
    },
    clickRotateImage: async function (index) {
      if (!index) { index = 0 }
      this.overlayShow = true
      const reqData = {
        'projectNumber': this.projectNumber,
        'userId': this.userId,
        'type': this.imageInfos[index].type,
        'displayOrder': this.imageInfos[index].displayOrder,
        'imagePath': this.imageInfos[index].filePath,
        'imageList': this.imageInfos
      }
      // dynamoのデータ更新、s3に画像アップロード
      const result = await SpecImageModel.putApi(this.$bvModal, reqData, () => {})
      this.imageInfos[index].filePath = result['images']['imagePath']
      this.overlayShow = false
    },
    clickUploadImage (displayOrder) {
      // 画像のアップロード
      document.getElementById('image-file-input-' + displayOrder).click()
    },
    uploadImage: async function (index, e) {
      if (!index) { index = 0 }
      if (typeof e.target.files[0] === 'undefined') {
        return false
      }

      const file = e.target.files[0]

      const extend = file.name.match(/[^.]+$/)[0]
      if (['PNG', 'png', 'JPG', 'JPEG', 'jpg', 'jpeg', 'GIF', 'gif'].includes(extend) === false) {
        this.$refs.commonModal.msgBoxOk('アップロード可能なファイル形式はjpeg・jpg・png・gifのみです。')
        return false
      }

      this.overlayShow = true

      await this.beforeResizeImage(file, this, index)
      let intervalflg = true
      const intervalId = setInterval(async () => {
        // resizeImagesに値がセットされたときに実行する
        if (intervalflg && this.resizeImages[index]) {
          // 定期実行を終了
          clearInterval(intervalId)
          intervalflg = false

          if (this.resizeImages[index].length > 4000000) {
            this.$refs.commonModal.msgBoxOk('アップロード可能なファイルサイズ上限は4MBです。')
            return false
          }

          const reqData = {
            'projectNumber': this.projectNumber,
            'userId': this.userId,
            'regist': [
              {
                'fileName': file.name,
                'type': this.imageInfos[index].type,
                'displayOrder': this.imageInfos[index].displayOrder,
                'imageData': this.resizeImages[index]
              }
            ],
            'imageList': this.imageInfos
          }
          const result = await SpecImageModel.postApi(this.$bvModal, reqData, (result) => {})
          this.imageInfos[index].filePath = result['images']['imagePath']
          this.imageInfos[index].isAddFile = true
          this.clickImage(index)
          this.overlayShow = false
          // 同名のファイルで再アップロードを可能とするために、アップロードファイルの情報を削除
          document.getElementById('image-file-input-' + index).value = ''
          this.resizeImages[index] = ''
        }
      }, 300)
    },
    clickDeleteImage: async function (index) {
      if (!index) { index = 0 }
      // 画像削除
      this.overlayShow = true
      const reqData = {
        'projectNumber': this.projectNumber,
        'userId': this.userId,
        'type': this.imageInfos[index].type,
        'displayOrder': this.imageInfos[index].displayOrder,
        'imagePath': this.imageInfos[index].filePath,
        'imageList': this.imageInfos
      }
      // dynamoのデータ削除、s3の画像削除
      await SpecImageModel.deleteApi(this.$bvModal, reqData, () => {})

      this.imageInfos[index]['filePath'] = null
      this.imageInfos[index]['isAddFile'] = false
      this.overlayShow = false
    },
    clickImage (index) {
      // 画像クリック時に行う特殊処理
      return index
    },
    resizeImage (imageData, num, canvasWidth, canvasHeight) {
      const canvas = document.createElement('canvas')
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      const ctx = canvas.getContext('2d')
      ctx.drawImage(imageData, 0, 0, canvasWidth, canvasHeight)

      this.resizeImages[num] = canvas.toDataURL('image/jpeg').replace(/^.*,/, '')

      canvas.height = 0
      canvas.width = 0
      canvas.remove()
      this.$delete(canvas)
    },
    beforeResizeImage (file, self, i) {
      const image = new Image()
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = (e) => {
        image.src = reader.result
        image.onload = (e) => {
          let canvasWidth = 0
          let canvasHeight = 0
          // 横幅と高さのいずれかが1280pxを超えている場合はリサイズ
          if (image.naturalWidth > 1280 || image.naturalHeight > 1280) {
            // アスペクト比計算
            const w = image.naturalWidth
            const h = image.naturalHeight
            const g = self.gcd(w, h)
            const ratioW = w / g
            const ratioH = h / g
            if (ratioW > ratioH) {
              // 横長画像(横幅 > 高さ)の場合
              canvasWidth = 1280
              canvasHeight = (1280 / ratioW) * ratioH
            } else {
              // 縦長画像(横幅 < 高さ)の場合
              canvasHeight = 1280
              canvasWidth = (1280 / ratioH) * ratioW
            }
          } else {
            canvasWidth = image.naturalWidth
            canvasHeight = image.naturalHeight
          }
          self.resizeImage(image, i, canvasWidth, canvasHeight)
        }
      }
    },
    gcd (x, y) {
      if (y === 0) {
        return x
      }
      return this.gcd(y, x % y)
    },
    toDataUrl (file) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
      })
    },
    clickBack () {
      this.$refs.commonModalBack.msgBoxConfirm('戻ると入力途中のデータは登録されません。よろしいですか？')
    },
    goBack () {
      // 前画面ができていればそれを直接指定する。
      localStorage.setItem('isPageBack', JSON.stringify(true))
      this.$router.push({
        name: 'ControlSpecList'
      })
    },
    goEdit () {
      // 編集画面へ遷移する。
      this.mode = 'edit'
      this.setIni()
    },
    goSpecInfo (seni = true) {
      // 案件情報画面を表示する。
      let path = this.projectNumberUrl
      if (this.mode === 'regist') {
        path += this.projectNumber
      }
      console.log(path)
      if (seni) {
        this.$router.push(path)
      } else {
        window.open(path, '_blank')
      }
    },
    goConfirmation () {
      // 参照画面へ遷移する。
      this.mode = 'confirmation'
      this.setIni()
    },
    validate () {
      if (!this.setSeason) {
        this.$refs.commonModal.msgBoxOk('季節が選択されておりません。')
        return false
      }
      if (this.setFacilityCode && !this.setFacilityName) {
        this.$refs.commonModal.msgBoxOk('施設コードに紐づく施設が存在しておりません。')
        return false
      }
      if (this.itemList.length <= 0) {
        this.$refs.commonModal.msgBoxOk('商品情報が追加されておりません。')
        return false
      }
      for (let i = 0; i < this.itemList.length; i++) {
        if (!this.isDecimal(this.itemList[i]['value']['メインゲスト数量']['value'])) {
          this.$refs.commonModal.msgBoxOk('商品' + (i + 1) + '行目の数量に数値を入力してください。')
          return false
        }
        if (!this.isNumeric(this.itemList[i]['value']['メインゲスト商品単価']['value'])) {
          this.$refs.commonModal.msgBoxOk('商品' + (i + 1) + '行目の商品単価に数値を入力してください。')
          return false
        }
        for (let j = i + 1; j < this.itemList.length; j++) {
          if (this.itemList[i]['value']['メインゲスト商品コード']['value'] === this.itemList[j]['value']['メインゲスト商品コード']['value']) {
            this.$refs.commonModal.msgBoxOk('商品コード' + this.itemList[i]['value']['メインゲスト商品コード']['value'] + 'が重複しています。')
            return false
          }
        }
      }
      return true
    },
    specUpdate: async function () {
      try {
        this.overlayShow = true
        console.log('更新処理開始')
        if (!this.validate()) {
          this.overlayShow = false
          return false
        }
        let reqData = {}
        reqData = this.getRegistData()
        // スペック情報を更新する
        reqData['projectNumber'] = this.projectNumber

        console.log(reqData)
        const result = await SpecListModel.postApi(this.$bvModal, reqData, (result) => {})
        console.log(result)
        this.overlayShow = false
        if ('status' in result && result['status'] === 'success') {
          this.goConfirmation()
          this.$refs.commonModal.msgBoxOk('更新が完了いたしました。')
        } else {
          this.$refs.commonModal.msgBoxOk('更新に失敗いたしました。')
        }
      } catch (error) {
        console.error(error)
        this.overlayShow = false
      }
    },
    specRegist: async function () {
      try {
        this.overlayShow = true
        console.log('登録処理開始')
        if (!this.validate()) {
          this.overlayShow = false
          return false
        }
        let reqData = {}
        reqData = this.getRegistData()
        reqData['案件ステータス'] = {'value': 'キャンセル'}
        const result = await SpecListModel.putApi(this.$bvModal, reqData, (result) => {})
        console.log(result)

        this.overlayShow = false
        if ('status' in result && 'id' in result && result['status'] === 'success') {
          // window.openで案件情報アプリを別タブで開く
          // この画面はスペック案件参考画面に遷移する
          this.projectNumber = result['id']
          await this.goSpecInfo(false)
          this.goConfirmation()
          this.$refs.commonModal.msgBoxOk('新規登録が完了いたしました。')
        } else {
          this.$refs.commonModal.msgBoxOk('新規登録に失敗いたしました。')
        }
      } catch (error) {
        console.error(error)
        this.overlayShow = false
      }
    },
    getRegistData () {
      let reqData = {}
      if (this.setAnkenFlg || this.mode !== 'regist') {
        reqData['案件フラグ'] = {'value': this.setAnkenFlg}
      }
      if (this.setSeason || this.mode !== 'regist') {
        reqData['季節'] = {'value': this.setSeason}
      }
      if (this.setSpecDate || this.mode !== 'regist') {
        reqData['施工日'] = {'value': this.setSpecDate}
      }
      if (this.setFacilityCode || this.mode !== 'regist') {
        reqData['施設コード'] = {'value': this.setFacilityCode}
      }
      if (this.setFacilityName) {
        reqData['施設名'] = {'value': this.setFacilityName}
      }
      /*
      if (this.setArea) {
        reqData['エリア'] = {'value': this.setArea}
      }
      if (this.setUnit) {
        reqData['ユニット'] = {'value': this.setUnit}
      }
      if (this.setStyle.length > 0) {
        reqData['スタイル'] = this.setStyle
      }
      if (this.setColor.length > 0) {
        reqData['色'] = this.setColor
      }
      */
      if (this.setTantosha && this.setTantoshaCode) {
        reqData['担当者'] = {'value': [{'name': this.setTantosha, 'code': this.setTantoshaCode}]}
      }
      reqData['メインゲスト商品テーブル'] = {'value': this.itemList}

      if (this.AnkenNumber) {
        reqData['案件番号'] = {'value': this.AnkenNumber}
      }
      return reqData
    },
    itemAdd () {
      let specRegistrationSetCondition = {}
      // 現在の入力値を保存して次画面に進む
      specRegistrationSetCondition['mode'] = this.mode
      specRegistrationSetCondition['setAnkenFlg'] = this.setAnkenFlg
      specRegistrationSetCondition['setSeason'] = this.setSeason
      specRegistrationSetCondition['setSpecDate'] = this.setSpecDate
      specRegistrationSetCondition['setFacilityCode'] = this.setFacilityCode
      specRegistrationSetCondition['setArea'] = this.setArea
      specRegistrationSetCondition['setUnit'] = this.setUnit
      specRegistrationSetCondition['setFacilityName'] = this.setFacilityName
      specRegistrationSetCondition['setStyle'] = this.setStyle
      specRegistrationSetCondition['setColor'] = this.setColor
      specRegistrationSetCondition['setMakeDate'] = this.setMakeDate
      specRegistrationSetCondition['setTantosha'] = this.setTantosha
      specRegistrationSetCondition['setTantoshaCode'] = this.setTantoshaCode
      specRegistrationSetCondition['setPlanningSheet'] = this.setPlanningSheet
      specRegistrationSetCondition['itemList'] = this.itemList
      specRegistrationSetCondition['imageInfos'] = this.imageInfos
      specRegistrationSetCondition['projectNumberUrl'] = this.projectNumberUrl
      specRegistrationSetCondition['projectNumber'] = this.projectNumber
      localStorage.setItem('specRegistrationSetCondition', JSON.stringify(specRegistrationSetCondition))
      this.$router.push({
        name: 'ControlItemSearch'
      })
    },
    itemDel (index) {
      this.overlayShow = true
      this.itemList.splice(index, 1)
      this.mathMainGuestPrice()
      this.overlayShow = false
    },
    autoChangeSeason (e) {
      this.overlayShow = true
      console.log(e.target.value)
      // ・１～３月：春花材
      // ・４～５月：初夏花材
      // ・６～８月：夏花材
      // ・９～１０月：秋花材
      // ・１１～１２月：冬花材
      const month = new Date(e.target.value.replace('-', '/')).getMonth() + 1
      if (month >= 1 && month <= 3) {
        this.setSeason = '春花材'
      } else if (month >= 4 && month <= 5) {
        this.setSeason = '初夏花材'
      } else if (month >= 6 && month <= 8) {
        this.setSeason = '夏花材'
      } else if (month >= 9 && month <= 10) {
        this.setSeason = '秋花材'
      } else if (month >= 11 && month <= 12) {
        this.setSeason = '冬花材'
      }
      this.overlayShow = false
    },
    autoChangeFacility: async function (e) {
      this.overlayShow = true
      console.log(e.target.value)

      const param = {
        'facilityCode': e.target.value
      }
      const result = await SearchFacilityModel.getApi(this.$bvModal, param, (result) => {})
      console.log(result)
      if ('records' in result && result['records'].length > 0) {
        this.setArea = result['records'][0]['担当エリア']['value']
        this.setUnit = result['records'][0]['担当ユニット']['value']
        this.setFacilityName = result['records'][0]['施設名']['value']
      } else {
        this.setArea = ''
        this.setUnit = ''
        this.setFacilityName = ''
      }
      this.overlayShow = false
    },
    autoChangeTantosha: async function (e) {
      console.log(e.target.value)
      this.setTantosha = ''
      for (let i = 0; i < this.tantoshaData.length; i++) {
        if (this.tantoshaData[i]['担当者']['value'][0]['code'] === e.target.value) {
          this.setTantosha = this.tantoshaData[i]['担当者']['value'][0]['name']
          break
        }
      }
      if (!this.setTantosha) {
        this.setTantoshaCode = ''
      }
    },
    autoChangeTantoshaCode: async function (e) {
      console.log(e.target.value)
      this.setTantoshaCode = ''
      for (let i = 0; i < this.tantoshaData.length; i++) {
        if (this.tantoshaData[i]['担当者']['value'][0]['name'] === e.target.value) {
          this.setTantoshaCode = this.tantoshaData[i]['担当者']['value'][0]['code']
          break
        }
      }
      if (!this.setTantoshaCode) {
        this.setTantosha = ''
      }
    },
    clickRotate (index) {
      this.$refs.commonModalRotate.msgBoxConfirm(this.consts.messages.imageRotate, index)
    },
    clickClear (index) {
      this.$refs.commonModalClear.msgBoxConfirm(this.consts.messages.imageClear, index)
    },
    pageBackDataSetUp: async function () {
      const specRegistrationSetCondition = JSON.parse(localStorage.getItem('specRegistrationSetCondition'))
      console.log(specRegistrationSetCondition)
      if (specRegistrationSetCondition) {
        for (const [key, value] of Object.entries(specRegistrationSetCondition)) {
          if (key === 'mode') {
            this.mode = value
          } else if (key === 'setAnkenFlg') {
            this.setAnkenFlg = value
          } else if (key === 'setSeason') {
            this.setSeason = value
          } else if (key === 'setSpecDate') {
            this.setSpecDate = value
          } else if (key === 'setFacilityCode') {
            this.setFacilityCode = value
          } else if (key === 'setArea') {
            this.setArea = value
          } else if (key === 'setUnit') {
            this.setUnit = value
          } else if (key === 'setFacilityName') {
            this.setFacilityName = value
          } else if (key === 'setStyle') {
            this.setStyle = value
          } else if (key === 'setColor') {
            this.setColor = value
          } else if (key === 'setMakeDate') {
            this.setMakeDate = value
          } else if (key === 'setTantosha') {
            this.setTantosha = value
          } else if (key === 'setTantoshaCode') {
            this.setTantoshaCode = value
          } else if (key === 'setPlanningSheet') {
            await this.setPlanningSheetUrl(value)
          } else if (key === 'itemList') {
            this.itemList = value
          } else if (key === 'imageInfos') {
            this.imageInfos = value
          } else if (key === 'projectNumberUrl') {
            this.projectNumberUrl = value
          } else if (key === 'projectNumber') {
            this.projectNumber = value
          }
        }
      }
      localStorage.removeItem('specRegistrationSetCondition')

      // 商品の追加
      const addSpecRegistrationItems = JSON.parse(localStorage.getItem('addSpecRegistrationItems'))
      console.log(addSpecRegistrationItems)
      if (addSpecRegistrationItems) {
        for (let i = 0; i < addSpecRegistrationItems.length; i++) {
          let addItem = addSpecRegistrationItems[i]
          let addData = {}
          addData['メインゲスト数量'] = {'type': 'NUMBER', 'value': 1}
          addData['メイン_ゲスト商品_大区分'] = {'type': 'SINGLE_LINE_TEXT', 'value': addItem['大区分']['value']}
          addData['メインゲスト商品コード'] = {'type': 'SINGLE_LINE_TEXT', 'value': addItem['商品コード']['value']}
          addData['メインゲスト商品名'] = {'type': 'SINGLE_LINE_TEXT', 'value': addItem['商品名']['value']}
          addData['メインゲスト商品単価'] = {'type': 'NUMBER', 'value': addItem['商品単価']['value']}
          addData['メインゲスト備考'] = {'type': 'SINGLE_LINE_TEXT', 'value': ''}
          addData['メイン_ゲスト商品_小区分'] = {'type': 'SINGLE_LINE_TEXT', 'value': addItem['小区分']['value']}
          addData['メインゲスト中区分'] = {'type': 'SINGLE_LINE_TEXT', 'value': addItem['中区分']['value']}
          addData['メインゲスト商品見積金額計'] = {'type': 'CALC', 'value': 0}
          addData['メインゲスト商品金額計'] = {'type': 'CALC', 'value': 0}
          if (addItem['中区分']['value'] === 'メインオプション' || addItem['中区分']['value'] === 'ゲストオプション') {
            addData['スペックオプション商品'] = {'type': 'SINGLE_LINE_TEXT', 'value': 'スペックオプション商品'}
          }
          this.itemList.push({'value': addData})
        }
      }
      this.changeAllKingaku()
      localStorage.removeItem('addSpecRegistrationItems')
    },
    dragStartList (event, dragIndex) {
      console.log('dragStartList')
      console.log(dragIndex)
      this.NowDragIndex = dragIndex
    },
    dragEndList (event) {
      console.log('dragEndList')
      this.NowDragIndex = -1
    },
    dropList (event, dragIndex) {
      console.log('dropList')
      console.log(this.NowDragIndex)
      if (this.NowDragIndex !== -1 && this.NowDragIndex !== dragIndex && (this.mode === 'regist' || this.mode === 'edit')) {
        console.log(dragIndex)
        this.overlayShow = true
        const cloneItem = this.itemList[this.NowDragIndex]
        const identity = (dragIndex - this.NowDragIndex > 0 ? 1 : -1)
        for (let i = this.NowDragIndex; i !== dragIndex; i += identity) {
          this.itemList[i] = this.itemList[i + identity]
        }
        this.itemList[dragIndex] = cloneItem
        this.NowDragIndex = -1
        this.overlayShow = false
      }
    },
    clickUploadPdf () {
      // 画像のアップロード
      document.getElementById('pdf-file-input-pdf').click()
    },
    clickClearPdf () {
      this.$refs.commonModalClearPdf.msgBoxConfirm(this.consts.messages.FileClear)
    },
    uploadPdf: async function (e) {
      if (typeof e.target.files[0] === 'undefined') {
        return false
      }

      const file = e.target.files[0]

      const extend = file.name.match(/[^.]+$/)[0]
      if (['PDF', 'pdf'].includes(extend) === false) {
        this.$refs.commonModal.msgBoxOk('アップロード可能なファイル形式はpdfのみです。')
        return false
      }

      this.overlayShow = true

      console.log(file)
      if (file.length > 4000000) {
        this.$refs.commonModal.msgBoxOk('アップロード可能なファイルサイズ上限は4MBです。')
        return false
      }

      this.setPlanningSheetData = await this.toDataUrl(file)
      console.log(this.setPlanningSheetData)

      const reqData = {
        'projectNumber': this.projectNumber,
        'userId': this.userId,
        'regist': {
          'fileName': file.name,
          'pdfData': this.setPlanningSheetData
        }
      }
      const result = await SpecPdfModel.postApi(this.$bvModal, reqData, (result) => {})
      await this.setPlanningSheetUrl(result['path'])
      this.overlayShow = false
      // 同名のファイルで再アップロードを可能とするために、アップロードファイルの情報を削除
      document.getElementById('pdf-file-input-pdf').value = ''
    },
    clickDeletePdf: async function () {
      // 画像削除
      this.overlayShow = true
      const reqData = {
        'projectNumber': this.projectNumber,
        'userId': this.userId,
        'regist': {
          'fileName': this.setPlanningSheetName,
          'pdfData': '',
          'filePath': this.setPlanningSheet
        }
      }
      await SpecPdfModel.postApi(this.$bvModal, reqData, (result) => {})

      await this.setPlanningSheetUrl('')
      this.overlayShow = false
    },
    setPlanningSheetUrl (url) {
      this.setPlanningSheet = url
      if (this.setPlanningSheet) {
        this.setPlanningSheetName = this.setPlanningSheet.split('/').slice(-1)[0]
      } else {
        this.setPlanningSheetName = ''
      }
    },
    setUserRoleMode () {
      const roleMode = {
        'システム管理者': 2,
        '運用管理者': 2,
        '本部マネージャー': 2,
        'エリアマネージャー': 1,
        'ユニットリーダー': 1,
        'チームリーダー': 1,
        'メンバー': 1,
        'プランナー': 0
      }
      this.userRoleMode = (this.userRole in roleMode) ? roleMode[this.userRole] : 0
    },
    changeToShapeName (proInfoData, masterData, type) {
      let strShapeData = ''
      if (type === 'main') {
        for (const i in masterData) {
          if (proInfoData.includes('"' + masterData[i]['value'] + '"')) {
            strShapeData += masterData[i]['label'] + '\n'
          }
        }
        if (strShapeData !== '') {
          strShapeData = strShapeData.slice(0, strShapeData.length - 1)
        }
      } else {
        for (const i in masterData) {
          if (proInfoData.includes('"' + masterData[i]['value'] + '"')) {
            strShapeData += masterData[i]['label'] + '\n'
          }
        }
        if (strShapeData !== '') {
          strShapeData = strShapeData.slice(0, strShapeData.length - 1)
        }
      }
      return strShapeData
    }
  },
  mounted () {
    this.setApiData()
  }
}
</script>
<style>
.label-condition {
  width: 150px;
}
.white-line {
  background-color: #fff;
}
.white-line:hover {
  background-color: #d9efff !important;
}
.gray-line {
  background-color: #eefdff;
}
.gray-line:hover {
  background-color: #d9efff !important;
}
.mw-100 {
  max-width: 100%;
}
.tile-image-dev {
  height: 140px;
}
.tile-image-height {
  max-height: 140px;
  height: auto;
}
.card-sqr-gray {
  border-radius: 0 !important;
  background-color: #ddd !important;
}
.item-note {
  font-size: 0.6rem!important;
  padding: 0px;
  overflow-y: hidden!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/ControlSpecRegistration.vue